import React from 'react'

import HeadingOfSections from './HeadingOfSection';
import { useTranslation } from 'react-i18next';
import Distribution from './Distribution.jsx';
import StockSection from './StockSection.jsx';
import StockFrigo from './StockFrigo.jsx';
import FrigoRooms from './FrigoRooms.jsx';


const Services = (props) => {
    const { t } = useTranslation();
  return (
    <section name='sales' className={`w-full flex flex-col gap-8 md:gap-14 xxl:gap-20 ${props.classmarginbottom} `}>
        <HeadingOfSections 
                header={t('homepage.servicesection.title')}
                span={t('homepage.servicesection.span')}
                text={t('homepage.servicesection.description')}/>
        <Distribution 
            padd={props.padd}
            motherclassName={props.motherclassName1}
            className1={props.className11}
            className2={props.className21}
            className3={props.className31}
            classmarginbottom={props.classmarginbottom1} 
            classbottom={props.classbottom1} 
            classText1={props.classText11}
            classwidth={props.classwidth1}
            classSectionText1={props.classSectionText11}
            classSectionText2={props.classSectionText21}
            classSectionText3={props.classSectionText31}
            classSectionText4={props.classSectionText41}
        />
        <StockSection 
            motherclassName={props.motherclassName}
            className1={props.className1}
            className2={props.className2}
            className3={props.className3}
            className4={props.className4}
            classiconpadd={props.classiconpadd}
            classicon={props.classicon}
            classGap1={props.classGap1}
            classAfter={props.classAfter}
            classAbsolute={props.classAbsolute}
            classHeader1={props.classHeader1}
            classText1={props.classText1}
            classHeader2={props.classHeader2}
            classHeader3={props.classHeader3}/>
        <StockFrigo 
            padd={props.padd}
            motherclassName={props.motherclassName1}
            className1={props.className11}
            className2={props.className21}
            className3={props.className31}
            classmarginbottom={props.classmarginbottom1} 
            classbottom={props.classbottom1} 
            classText1={props.classText11}
            classwidth={props.classwidth1}
            classSectionText1={props.classSectionText11}
            classSectionText2={props.classSectionText21}
            classSectionText3={props.classSectionText31}
            classSectionText4={props.classSectionText41}
        />
        <FrigoRooms
            padd={props.padd2}
            motherclassName={props.motherclassName2}
            className1={props.className12}
            className2={props.className22}
            className3={props.className32}
            className4={props.className42}
            className5={props.className52}
          />
    </section>
  )
}

export default Services